import { render, staticRenderFns } from "./QOrganizationInfo.vue?vue&type=template&id=45869b89&scoped=true"
import script from "./QOrganizationInfo.vue?vue&type=script&lang=js"
export * from "./QOrganizationInfo.vue?vue&type=script&lang=js"
import style0 from "./QOrganizationInfo.vue?vue&type=style&index=0&id=45869b89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45869b89",
  null
  
)

/* custom blocks */
import block0 from "./QOrganizationInfo.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports